import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CalendarClock } from 'lucide-react';
import PortalTopBar from '../../components/academy/PortalTopBar';
import { useAuth } from '../../context/AuthContext';

export default function Schedule() {
  const { api } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/academy/my/schedule')
      .then(({ data }) => setRows(data.rows || []))
      .finally(() => setLoading(false));
  }, [api]);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <PortalTopBar />
      <main className="max-w-[1100px] mx-auto px-4 lg:px-6 py-8">
        <Link to="/academy/dashboard" className="inline-flex items-center gap-1.5 text-[13px] text-[#6E6E73] hover:text-[#c9a227] mb-4">
          <ArrowLeft className="w-3.5 h-3.5" /> Dashboard
        </Link>
        <h1 className="text-[28px] font-extrabold text-[#1D1D1F] mb-1">Class Schedule &amp; Grades</h1>
        <p className="text-[14px] text-[#6E6E73] mb-6">Your active class times, instructor, and current grades.</p>

        {loading ? (
          <div className="text-[#6E6E73] text-[14px]">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-[#E5E5E7] bg-white p-10 text-center">
            <CalendarClock className="w-10 h-10 text-[#c9a227] mx-auto mb-3" />
            <div className="text-[16px] font-bold text-[#1D1D1F]">No active classes</div>
            <p className="text-[13.5px] text-[#6E6E73]">Enrol in a program to see your schedule here.</p>
          </div>
        ) : (
          <div className="rounded-2xl overflow-hidden border border-[#E5E5E7] bg-white">
            <table className="w-full text-[14px]">
              <thead className="bg-[#0e0e10] text-white">
                <tr>
                  <th className="px-5 py-3 text-left text-[11px] font-bold tracking-[0.18em] uppercase">Course</th>
                  <th className="px-5 py-3 text-left text-[11px] font-bold tracking-[0.18em] uppercase">Schedule</th>
                  <th className="px-5 py-3 text-left text-[11px] font-bold tracking-[0.18em] uppercase">Progress</th>
                  <th className="px-5 py-3 text-left text-[11px] font-bold tracking-[0.18em] uppercase">Grade</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E5E5E7]">
                {rows.map((r, i) => (
                  <tr key={i} data-testid={`schedule-row-${i}`}>
                    <td className="px-5 py-3 font-bold text-[#1D1D1F]">{r.program_name}</td>
                    <td className="px-5 py-3 text-[#6E6E73]">{r.schedule || 'Self-paced'}</td>
                    <td className="px-5 py-3">
                      <div className="h-1.5 w-32 rounded-full bg-[#F5F5F7] overflow-hidden">
                        <div className="h-full bg-gradient-to-r from-[#e6c35a] to-[#a8871a]" style={{ width: `${r.progress || 0}%` }} />
                      </div>
                      <div className="text-[11px] text-[#6E6E73] mt-1">{r.progress || 0}%</div>
                    </td>
                    <td className="px-5 py-3 text-[#1D1D1F]">{r.grade || <span className="text-[#9ca3af]">—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
